import { useQuery } from "@tanstack/react-query"
import { getTransferAttachmentList } from "customerAttachments/apis"

const useGetTransferAttachList = (transferId: string) => {
  const { data, isLoading } = useQuery({
    enabled: !!transferId,
    queryKey: ["transferAttachments", transferId],
    queryFn: () => getTransferAttachmentList(transferId),
    select: (data) => data?.Data,
  })
  return { data, isLoading }
}

export default useGetTransferAttachList
